import Big from 'big.js';
import { parseValue, replaceDecimalSeparator } from './strings';

Big.RM = 0;

export const validatePositive = (value: string) => {
  const stringValue = parseValue(replaceDecimalSeparator(value));
  const bigValue = Big(stringValue);
  return bigValue.gt(0);
};

export const validateAmountPrecision = (value: string, precision = 2) => {
  const formattedValue = replaceDecimalSeparator(value);
  if (formattedValue.includes('.')) {
    return formattedValue.split('.')[1].length <= precision;
  }
  return true;
};
